// extracted by mini-css-extract-plugin
module.exports = {"container":"noSearchResults_container__b3RMI","headline":"noSearchResults_headline__FPH0D"};